/** True when the API rejected handoff because no BioFlow account exists yet. */
export function isBioFlowCredentialsRequired(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const message = error.message;
  if (typeof message === "string") {
    return message.includes("credentials_required") || message.includes("password_required");
  }
  if (Array.isArray(message)) {
    return message.some(
      (m) =>
        String(m).includes("credentials_required") ||
        String(m).includes("password_required"),
    );
  }
  return false;
}
